import { Link } from "react-router";
import type { ExpenseDetail } from "@/lib/expenses/expense-detail";
import { ExpenseDetailView } from "@/components/expenses/expense-detail-view";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = ExpenseDetail;

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/expenses/${seg(params.id!)}`);
}

export default function ExpenseDetailPage() {
  const expense = useLoaderData() as Data;
  const now = new Date();

  return (
    <div className="flex flex-col gap-6">
      <nav className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[13px] text-fc-text-secondary">
          <Link to="/admin" className="text-fc-text-dim hover:text-fc-text">
            Home
          </Link>
          <span className="text-fc-text-dim">/</span>
          <Link
            to="/admin/expenses"
            className="text-fc-text-dim hover:text-fc-text"
          >
            Expenses
          </Link>
          <span className="text-fc-text-dim">/</span>
          <span className="font-medium text-fc-text font-mono">
            e_{expense.id.slice(0, 8)}
          </span>
        </div>
        <Link
          to="/admin/expenses"
          className="inline-flex items-center gap-2 rounded-md border border-fc-border bg-fc-overlay px-3 py-1.5 text-[12.5px] text-fc-text hover:border-fc-brand"
        >
          ← Back to list
        </Link>
      </nav>

      <ExpenseDetailView expense={expense} now={now} />
    </div>
  );
}
